
import React, { useEffect, useState, useRef } from "react";
import API from "../Services/Auth"
import API1 from "../Services/Inventory"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CenterModal from '../Components/CenterModal'
import InventoryMapList from "./InventoryMapList";

const InventoryLocationMap = () => {
  const [measurementUnit, setMeasurementUnit] = useState("");
  const [measurementUnits, setMeasurementUnits] = useState([]);
  const [openingStock, setOpeningStock] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedCenter, setSelectedCenter] = useState([]);
  const [price, setPrice] = useState("");
  const [uomQty, setUomQty] = useState("");
  const [inventories, setInventories] = useState([]);
  const [selectedInventory, setSelectedInventory] = useState("");
  useEffect(() => {
  //  bindMeasurementUnit();
    bindInventoryList();
  }, [])

  const bindInventoryList = async () => {
    try {
      const response = await API1.Get_inventory_List({ is_active: 1, limit: 0 });
      setInventories(response?.data?.data || []);
    } catch (error) {
      console.error(error);
      if (error.response?.status === 403) {
        window.location.replace("/Login");
      }
    }
  };

  const validateFields = () => {
    const errors = {};
    if (!measurementUnit.trim()) {
      errors.measurementUnit = "Measurement Unit is required";
    }
    const stockRegex = /^[0-9]+$/;
    if (!openingStock.trim()) {
      errors.openingStock = "Opening Stock is required";
    } else if (!stockRegex.test(openingStock)) {
      errors.openingStock = "Opening Stock must be a numeric value";
    }

    if (!price.trim()) {
      errors.price = "Price is required";
    } else if (!/^\d+(\.\d{1,2})?$/.test(price)) {
      errors.price = "Price must be a numeric value";
    }

    if (!uomQty.trim()) {
      errors.uomQty = "UOM Quantity is required";
    } else if (!/^\d+$/.test(uomQty)) {
      errors.uomQty = "UOM Quantity must be a numeric value";
    }
    if (!selectedInventory) {
      errors.selectedInventory = "Inventory is required";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFieldChange = (e, fieldName) => {
    const value = e.target.value;
    if (value?.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[fieldName];
        return updatedErrors;
      });
    }
    switch (fieldName) {
      case "measurementUnit":
        setMeasurementUnit(value);
        break;
      case "openingStock":
        setOpeningStock(value);
        break;
      case "price":
        setPrice(value);
        break;
      case "uomQty":
        setUomQty(value);
        break;
      case "selectedInventory":
      setSelectedInventory(value);

      const selectedInv = inventories.find((inv) => inv.id == value);

      if (selectedInv && selectedInv.unit) {
        bindMeasurementUnit(selectedInv.unit);
      }
        break;
      default:
        break;
    }
  };

  const bindMeasurementUnit = async (type = null) => {
    let payload = {
      is_active: 1,
      
    }
    if (type != null) {
      payload = {
        is_active: 1,
        type
      }
    }
    const response = await API.bindMeasurementUnit(payload)
    setMeasurementUnits(response.data.data.rows)
  }
  const handleSubmit = async () => {
    if (!validateFields()) return;
    const location_id = Array.isArray(selectedCenter) ? selectedCenter.join(", ") : selectedCenter;
    const isMultiple = location_id.length === 1 ? 0 : 1;
    const payload = {
      inventory_id: selectedInventory,
      location_id: location_id,
      unit_id: parseInt(measurementUnit),
      price: parseFloat(price),
      uom_qty: parseInt(uomQty),
      opening_stock: openingStock,
      is_multiple: isMultiple
    };

    try {
      const response = await API1.addInventoryLocation(payload);
      if (response.status === 200) {
        toast.success(response?.data?.message);
        setTimeout(() => window.location.reload(), 2000);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data.message || "Bad Request");
      }
      else if (error.response.status === 403) {
        window.location.replace("/Login");
      }
      else {
        toast.error("An unexpected error occurred");
      }
    }
  };

  const handleCancel = () => {
    setTimeout(() => window.location.reload());
  }
  const handleSelectedCenter = (selectedData) => {
    setSelectedCenter(selectedData);
  };

  return (
    <div>
      <div className="col-12 grid-margin stretch-card">
        <div className="card">
          <div>
            <div className="card-body">
              <h4 className="card-title">Map Ingredient Center</h4>
              <div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <CenterModal onSelectCenter={handleSelectedCenter} />
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="ddInventory" className="form-label">
                        Inventory Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className={`form-select ${errors.selectedInventory ? "is-invalid" : ""}`}
                        id="ddInventory"
                        value={selectedInventory}
                        onChange={(e) => handleFieldChange(e, "selectedInventory")}
                      >
                        <option value="">Select Inventory</option>
                        {inventories.map((inv) => (
                          <option key={inv.id} value={inv.id}>
                            {inv.name}
                          </option>
                        ))}
                      </select>
                      {errors.selectedInventory && (
                        <div className="invalid-feedback">{errors.selectedInventory}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="ddMeasurementUnit" className="form-label">
                        Measurement Unit <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className={`form-select ${errors.measurementUnit ? "is-invalid" : ""}`}
                        id="ddMeasurementUnit"
                        value={measurementUnit}
                        onChange={(e) => handleFieldChange(e, "measurementUnit")}
                      >
                        <option value="">Select Unit </option>
                        {measurementUnits.map((unit) => (
                          <option key={unit.id} value={unit.id}>
                            {unit.name}
                          </option>
                        ))}
                      </select>
                      {errors.measurementUnit && (
                        <div className="invalid-feedback">{errors.measurementUnit}</div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="txtstock" className="form-label">
                        Opening Stock <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.openingStock ? "is-invalid" : ""}`}
                        id="txtstock"
                        placeholder="Stock"
                        value={openingStock}
                        onChange={(e) => handleFieldChange(e, "openingStock")}
                      />
                      {errors.openingStock && (
                        <div className="invalid-feedback">{errors.openingStock}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="txtPrice" className="form-label">
                       <span className="mdi mdi-currency-rupee"></span> Price <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.price ? "is-invalid" : ""}`}
                        id="txtPrice"
                        placeholder="Price"
                        value={price}
                        onChange={(e) => handleFieldChange(e, "price")}
                      />
                      {errors.price && <div className="invalid-feedback">{errors.price}</div>}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="txtUOMQty" className="form-label">
                        UOM Quantity <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.uomQty ? "is-invalid" : ""}`}
                        id="txtUOMQty"
                        placeholder="UOM Quantity"
                        value={uomQty}
                        onChange={(e) => handleFieldChange(e, "uomQty")}
                      />
                      {errors.uomQty && <div className="invalid-feedback">{errors.uomQty}</div>}
                    </div>
                  </div>
                </div>
                <div className="mt-3">
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn btn-primary me-2"
                  >
                    Submit
                  </button>
                  <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <InventoryMapList />
      <ToastContainer />
    </div>

  );
};

export default InventoryLocationMap;
